import { CountResponse } from "../../../common/api/Models/CountResponse";
import { useAxiosGet } from "../../../infrastructure/http";

export function useGetCounts(userLocation?: number, manual?: boolean) {
	let queryString = userLocation ? `?locationId=${userLocation}` : '';
	return useAxiosGet<CountResponse[]>(`/Count${queryString}`, manual ?? false);
}
